import { useEffect } from 'react';
import { useCartStore } from '../store/cartStore';
import { useAuthStore } from '../store/authStore'; // Assuming you have an auth store
import { getToken } from '../utils/tokenHelper';

const CartInitializer = () => {
  const { fetchCart } = useCartStore();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const token = useAuthStore((state) => state.token);

  // Check if token is accessible at component mount
  useEffect(() => {
    const tokenFromStore = token;
    const tokenFromHelper = getToken();
    const tokenFromLocalStorage = localStorage.getItem('token');
    
  }, [token]);

  // Fetch cart data from API when component mounts and user is authenticated with a token
  useEffect(() => {
    // Only fetch cart if we have both authentication and a token
    if (isAuthenticated && token) {
      // console.log("Initializing cart with token:", token);
      fetchCart().catch((error) => {
        console.error('Error initializing cart:', error);
      });
    } else {
      console.log("Not fetching cart: User not authenticated or no token available");
    }
  }, [fetchCart, isAuthenticated, token]);

  // This component doesn't render anything
  return null;
};

export default CartInitializer; 